<template>
    <span v-if="color" class="block rounded-full shrink-0" :style="{ backgroundColor: color }" aria-hidden="true" />
</template>

<script setup lang="ts">
import { getPerspectiveColor } from "~vue/utils/perspectiveUtils";
import { computed } from "vue";

const { letters } = defineProps<{ letters: string | null | undefined }>();

const color = computed(() => getPerspectiveColor(letters));
</script>
